import * as React from "react";
import { browserName } from "react-device-detect";

import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Button, Card, CardContent, CardHeader, Divider } from "@mui/material";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import { useSelector } from "react-redux";
import { selectUser } from "../../utilities/auth/authSlice";
import { CalendarService, UserProfileService } from "../../../services/intranet-portal-services";
import LinkIcon from "@mui/icons-material/Link";
import { useSearchParams } from "react-router-dom";
interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps): React.ReactElement {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </Box>
  );
}

function a11yProps(index: number): {
  id: string;
  "aria-controls": string;
} {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}

const Calendar = (): React.ReactElement => {
  const theme = useTheme();
  const { handleRequest } = useIntranetPortalCoreApi();
  const [employeeDetails, setEmployeeDetails] = React.useState<any>();
  const [calendarUrl, setCalendarUrl] = React.useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const user = useSelector(selectUser);
  const id = user?.profile?.sub;

  const tabValues = ["personal", "amnil"];
  const currentTab = searchParams.get("calendarTab") ?? "personal";
  const tabIndex = tabValues.indexOf(currentTab);

  const getEmployeeFullProfile = async (): Promise<void> => {
    await handleRequest(() =>
      UserProfileService.getCoreApiApiAppUserProfileUserProfileById(id)
    ).then((response) => {
      if (response != null) {
        setEmployeeDetails(response);
      }
    });
  };

  const getCalendarUrl = async (): Promise<void> => {
    await handleRequest(() =>
      CalendarService.getCoreApiApiAppCalendarPublicGoogleCalendarUrl()
    ).then((response) => {
      if (response != null) {
        setCalendarUrl(response);
      }
    });
  };

  React.useEffect(() => {
    tabIndex === 0 ? void getEmployeeFullProfile() : void getCalendarUrl();
  }, [tabIndex]);

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    const newParams = new URLSearchParams(searchParams);

    if (newValue !== 0) {
      newParams.set("calendarTab", tabValues[newValue]);
    } else {
      newParams.delete("calendarTab");
    }

    setSearchParams(newParams);
  };

  // const handleChangeIndex = (index: number): void => {
  //   setValue(index)
  // }
  //  const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  return (
    <Card sx={{ mb: "1rem", maxHeight: "100%" }} elevation={1}>
      <CardHeader title="Calendar" />
      <Divider />
      <CardContent>
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <AppBar position="static">
            <Tabs
              value={tabIndex}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab
                label={
                  <Typography variant="body1" color={"white"}>
                    Personal Calendar
                  </Typography>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <Typography variant="body1" color={"white"}>
                    Amnil Calendar
                  </Typography>
                }
                {...a11yProps(1)}
              />
            </Tabs>
          </AppBar>

          <TabPanel value={tabIndex} index={0} dir={theme.direction}>
            <>
              <Box className="googleCalendarUi">
                {browserName === "Chrome" ? (
                  <>
                    {employeeDetails?.email !== null ? (
                      <iframe
                        src={
                          "https://calendar.google.com/calendar/embed?src=" +
                          encodeURI(employeeDetails?.email)
                        }
                        width={800}
                        height={600}
                      ></iframe>
                    ) : (
                      <Box component="span" style={{ alignContent: "center" }}>
                        No Calendar Available
                      </Box>
                    )}
                  </>
                ) : (
                  <a
                    target="#blank"
                    href={
                      "https://calendar.google.com/calendar/embed?src=" +
                      encodeURI(employeeDetails?.email)
                    }
                    style={{ display: "inline-block" }}
                  >
                    {/* <AnimateButton> */}
                    <Button
                      sx={{
                        mt: 2,
                        background: "#292929",
                        color: "white",
                        ":hover": {
                          boxShadow: "0 2px 14px 0 rgb(32 40 45 / 8%)",
                          background: "#020202"
                        }
                      }}
                      disableElevation
                      size="large"
                      type="submit"
                    >
                      Click to see your personal calendar <LinkIcon style={{ marginLeft: 3 }} />
                    </Button>
                    {/* </AnimateButton> */}
                  </a>
                )}
              </Box>
            </>
          </TabPanel>

          <TabPanel value={tabIndex} index={1} dir={theme.direction}>
            <>
              <Box className="googleCalendarUi">
                {browserName === "Chrome" ? (
                  <>
                    {calendarUrl !== null ? (
                      <iframe src={calendarUrl} width={800} height={600}></iframe>
                    ) : (
                      <Box component="span" style={{ alignContent: "center" }}>
                        Amnil Calendar Not Available
                      </Box>
                    )}
                  </>
                ) : (
                  <a
                    target="#blank"
                    href={`${calendarUrl}`}
                    style={{
                      textDecoration: "none",
                      display: "inline-block"
                    }}
                  >
                    <Button
                      sx={{
                        mt: 2,
                        background: "#292929",
                        color: "white",
                        ":hover": {
                          boxShadow: "0 2px 14px 0 rgb(32 40 45 / 8%)",
                          background: "#020202"
                        }
                      }}
                      disableElevation
                      size="large"
                      type="submit"
                    >
                      Click to see Amnil Calendar
                      <LinkIcon style={{ marginLeft: 3 }} />
                    </Button>
                  </a>
                )}
              </Box>
            </>
          </TabPanel>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Calendar;
